export const RevolutClientId = import.meta.env.REACT_APP_ENV === 'production' ? 2398 : 1742;
